// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-theme="black"] {
    --primary: #404754;
    &[data-mode="dark"] {
        --background: #1F2227;
        --color: #abb2bf;
        --bar-background: #24272D;
        --bar-color: #6C6E74;
        --border-color: #373A40; 
        --active-border-color: #656973;
        --hover-background: #2D3139;
        --selected-background: #333841;
        --selected-color: #d7dae0;
        --drop-background: #142E48;
    }
    &[data-mode="light"] {
        --background: #fff;
        --color: #1F2227; 
        --bar-background: #F7F8FA;
        --bar-color: #676D75;
        --border-color: #D2D7DE;
        --active-border-color: #373A40;
        --hover-background: #d1d3d6;
        --selected-background: #E9EBEE;
        --selected-color: #15181c;
        --drop-background: #b8c0c8;
    }
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
